import React, { useEffect, useState } from "react";
import DashboardHeader from "../DashboardHeader/DashboardHeader";
import "./Settings.css";
import { useGlobalContext } from "../../../context/context";
import ProfileDetails from "../ProfileDetails/ProfileDetails";
import UpdateProfile from "../UpdateProfile/UpdateProfile";
import { FiEdit2, FiUser } from "react-icons/fi";

const readSession = (key) => {
  try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; }
};

const Settings = () => {
  const [tab, setTab] = useState(1);
  const { userDetails, getUser, userLoading, userError } = useGlobalContext();
  const cachedUser = readSession("user") || {};
  const user = userDetails && !Array.isArray(userDetails) && Object.keys(userDetails).length ? userDetails : cachedUser;
  const token = readSession("accessToken");
  useEffect(() => {
    getUser(token, user?._id);
  }, []);

  return (
    <section className="settings pg-settings">
      <div className="pg-settings-top"><DashboardHeader pathname={user?.firstName || "Account"} /></div>
      <main className="pg-settings-content">
        <header className="pg-profile-hero">
          <div className="pg-profile-avatar" aria-hidden="true"><FiUser size={24} /></div>
          <div className="pg-profile-heading">
            <span className="pg-kicker">PERSONAL ACCOUNT</span>
            <h1>{[user?.firstName, user?.lastName].filter(Boolean).join(" ") || "Profile details"}</h1>
            <p>Keep your saved details current and easy to find.</p>
          </div>
          <button type="button" className="pg-edit-button" onClick={() => setTab(2)} data-testid="button-edit-profile">
            <FiEdit2 size={15} /> Update details
          </button>
        </header>

        <div className="pg-profile-layout">
          <aside className="pg-profile-rail">
            <span className="pg-rail-title">ACCOUNT</span>
            <button type="button" className={tab === 1 ? "is-selected" : ""} onClick={() => setTab(1)} aria-current={tab === 1 ? "page" : undefined}>
              <FiUser size={17} /> Profile details
            </button>
            <button type="button" className={tab === 2 ? "is-selected" : ""} onClick={() => setTab(2)} aria-current={tab === 2 ? "page" : undefined}>
              <FiEdit2 size={16} /> Update profile
            </button>
            <div className="pg-rail-note"><span className="pg-rail-dot" /> Details saved to your account</div>
          </aside>
          <section className="pg-profile-panel">
            {userLoading && !Object.keys(user || {}).length ? (
              <div className="pg-profile-skeleton" aria-label="Loading profile details">
                <div className="pg-skeleton-heading" />
                <div className="pg-skeleton-grid">{Array.from({ length: 8 }).map((_, index) => <div className="pg-skeleton-row" key={index}><i /><b /></div>)}</div>
              </div>
            ) : userError && !Object.keys(user || {}).length ? (
              <div className="pg-profile-error" role="alert">
                <h2>Profile details are unavailable</h2>
                <p>We couldn't load your saved information. Check your connection and try again.</p>
                <button type="button" onClick={() => getUser(token, user?._id)}>Retry</button>
              </div>
            ) : tab === 1 ? <ProfileDetails onEdit={() => setTab(2)} /> : <UpdateProfile setTab={setTab} />}
          </section>
        </div>
      </main>
    </section>
  );
};

export default Settings;
